module.exports = fox._r("images/bg_player.gif", __webpack_public_path__ + "images/bg_player.gif");


//////////////////
// WEBPACK FOOTER
// ./images/bg_player.gif
// module id = 1018
// module chunks = 4